module.exports = "pegasus_template/assets/blocks/social-2-theme5.png";